import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';
import { Button } from 'ui-components/components/button';

import style from './manage-item-grid.module.less';

const messages = defineMessages({
  actions: {
    description: 'manageItemGrid.actions',
    defaultMessage: 'Actions',
    id: 'l9Rff3',
  },
});

export const ManageItemGrid = ({ columns, items, onItemEdited = noop, onItemDeleted = noop }) => {
  const [actionWidth, setActionWidth] = useState();

  const measuredRef = useCallback((node) => {
    if (node !== null) {
      setActionWidth(node.getBoundingClientRect().width);
    }
  }, []);

  const realColumns = [
    ...columns,
    {
      name: <FormattedMessage {...messages.actions} />,
      itemRenderer: (item) => (
        <div ref={measuredRef} className={style['action-column-wrapper']}>
          <div className={style['action-column']}>
            <Button onClick={() => onItemEdited(item)} theme='link'>
              <FormattedMessage defaultMessage='Edit' description='manageItemGrid.edit' id='/COlGI' />
            </Button>
            <Button onClick={() => onItemDeleted(item)} theme='danger-link'>
              <FormattedMessage defaultMessage='Delete' description='manageItemGrid.delete' id='uF2v4d' />
            </Button>
          </div>
        </div>
      ),
      headerClassName: style['action-column-header'],
      width: actionWidth,
    },
  ];
  const nonFirstColumnsWidth = realColumns.reduce((sum, column, index) => {
    if (index === 0) {
      return sum;
    }
    return sum + column.width + 15;
  }, 0);
  realColumns[0].width = `calc(100% - ${nonFirstColumnsWidth}px`;
  return (
    <div className={style['manage-item-grid']}>
      <div className={style.header}>
        {realColumns.map((column) => (
          <div
            key={column.name}
            className={classnames(style['header-item'], column.headerClassName)}
            style={{ width: column.width, minWidth: column.width }}
          >
            {column.name}
          </div>
        ))}
      </div>
      <div className={style.rows}>
        {items.map((item, index) => (
          <div key={index} className={style['grid-row']} role='row'>
            {realColumns.map((column) => (
              <div key={`${index}${column.name}`} className={style['row-item']} style={{ width: column.width }}>
                {column.itemRenderer(item)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

ManageItemGrid.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      itemRenderer: PropTypes.func,
      width: PropTypes.number,
      headerClassName: PropTypes.string,
    }),
  ).isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onItemEdited: PropTypes.func,
  onItemDeleted: PropTypes.func,
};
